(function() {
    'use strict';

    angular.module('product')
        .controller('DiscountListController', DiscountListController);

    DiscountListController.$inject = ['$state', '$q', 'discountDataSrvc', 'lodashService', 'notificationSrvc', 'discountMessagesConst', 'errorNotificationSrvc', 'discountModalSrvc', 'modalSrvc'];

    function DiscountListController($state, $q, discountDataSrvc, lodashService, notificationSrvc, discountMessagesConst, errorNotificationSrvc, discountModalSrvc, modalSrvc) {
        var self = this;

        self.uploading = false;
        self.importData = {
            file: null
        };
        self.importServerErrors = {
            file: []
        }
        self.loading = false;
        self.ignoreChanges = false;
        self.treeData = null;
        self.treeConfig = {
            core : {
                multiple: true,
                animation: true,
                error: function(error) {
                    console.log("ERR", error);
                },
                check_callback: true,
                worker: true,
                themes: {
                    variant : "large"
                }
            },
            types : {
                default : {
                    icon : 'fa fa-lg fa-folder'
                },
                product : {
                    icon : 'fa fa-lg fa-cube'
                }
            },
            version : 1,
            plugins : ['types', 'state']
        };
        self.treeInstance = null;
        self.selectedDiscount = null;
        self.selectedDiscountsIDs = [];
        self.selectedMultipleDiscountsValue = 0;
        self.serverErrors = null;

        self.ignoreModelChanges = ignoreModelChanges;
        self.onReady = onReady;
        self.onNodeSelect = onNodeSelect;
        self.updateDiscount = updateDiscount;
        self.updateMultipleDiscounts = updateMultipleDiscounts;
        self.clearErrors = clearErrors;
        self.addQuantityDiscount = addQuantityDiscount;
        self.updateDiscountsForQuantity = updateDiscountsForQuantity;
        self.deleteQuantityDiscount = deleteQuantityDiscount;
        self.handleClick = handleClick;
        self.cleanImportErrors = cleanImportErrors;
        self.importDiscountsFromFile = importDiscountsFromFile;

        activate();

        function activate() {
            self.loading = true;
            $q.all([getDiscountTree()]).then(
                function () {
                    self.loading = false;
                },
                function () {
                    self.loading = false;
                }
            );
        }

        function getDiscountTree() {
            return discountDataSrvc.list().$promise.then(
                function (response) {
                    self.ignoreChanges = true;
                    self.treeData = response;
                    self.treeConfig.version++;
                },
                function (response) {
                    notificationSrvc.notification("error", discountMessagesConst.listError);
                }
            );
        }

        function ignoreModelChanges() {
            return !self.ignoreChanges;
        }

        function onReady() {
            self.ignoreChanges = false;
        }

        function onNodeSelect(node, selected, event) {
            self.selectedDiscountsIDs = selected.selected;
            self.selectedDiscount = lodashService.find(self.treeData, function (item) {
                return item.id === selected.node.original.id;
            })
        }

        function updateDiscount(discount) {
            self.loading = true;

            var payload = {
                value: discount.value
            };

            if (discount.is_can_edit_secondary){
                payload['secondary_value'] = discount.secondary_value
            }

            discountDataSrvc.update({pk: discount.id}, payload).$promise.then(
                function (response) {
                    activate();
                    notificationSrvc.notification("success", discountMessagesConst.updateSuccess);
                },
                function (response) {
                    self.loading = false;
                    self.serverErrors = response;
                    errorNotificationSrvc.displayErrors(response.data);
                }
            )
        }

        function updateMultipleDiscounts(discountsIDs) {
            self.loading = true;
            var promises = discountsIDs.map(function(id) {
                return discountDataSrvc.update({
                    pk: id
                }, {
                    value: self.selectedMultipleDiscountsValue
                }).$promise;
            });
            $q.all(promises).then(function(response){
                activate();
                notificationSrvc.notification("success", discountMessagesConst.updateSuccess);
                self.selectedMultipleDiscountsValue = 0;
            }, function(response){
                self.loading = false;
                self.serverErrors = response;
                errorNotificationSrvc.displayErrors(response.data);
                self.selectedMultipleDiscountsValue = 0;
            });
        }

        function clearErrors() {
            self.serverErrors = null;
        }

        function handleClick(event) {
            var target = event.target;
            if (target.classList.contains("add-discount-quantity")) {
                self.addQuantityDiscount(target);
            } else if (target.classList.contains("update-discount-quantity")) {
                self.updateDiscountsForQuantity(target);
            } else if (target.classList.contains("delete-discount-quantity")) {
                self.deleteQuantityDiscount(target);
            }
        }

        // The label of the product discount as the tree shows it (ID | name).
        function getNodeLabel(target) {
            var label = angular.element(target).parent().parent()[0].querySelector('span');
            return label ? label.textContent.replace(/\s*\[[^\]]*\]/g, '').trim() : '';
        }

        function addQuantityDiscount(target) {
            // get li element with id for discount object
            var discount_id = parseInt(angular.element(target).parent().parent()[0].id);
            modalSrvc.confirmAction(
                // The dialog adds "Czy na pewno chcesz" in front and "?" at the end.
                'dodać rabaty dla nakładów produktu ' + getNodeLabel(target) +
                ' (rabaty z wartością 0 zostaną utworzone dla wszystkich nakładów produktu ' +
                'i pojawią się w każdej kategorii, w której jest produkt)',
                function() {
                    self.loading = true;
                    discountDataSrvc.createDiscountForQuantity({
                        id: discount_id
                    }).$promise.then(function(response) {
                        notificationSrvc.notification("success", discountMessagesConst.updateSuccess);
                        activate();
                    }, function(response) {
                        errorNotificationSrvc.displayErrors(response.data);
                        self.loading = false;
                    })
                },
                angular.noop
            );
        }

        function updateDiscountsForQuantity(target){
            var discountId = parseInt(angular.element(target).parent().parent()[0].id);
            discountModalSrvc.updateModal({discountId: discountId}, activate, angular.noop)
        }

        function deleteQuantityDiscount(target) {
            // get li element with id for discount object
            var discount_id = parseInt(angular.element(target).parent().parent()[0].id);
            modalSrvc.confirmAction(
                'usunąć rabaty dla nakładów produktu ' + getNodeLabel(target) +
                ' w tej kategorii razem z ich wartościami (tej operacji nie można cofnąć)',
                function() {
                    self.loading = true;
                    discountDataSrvc.deleteDiscountForQuantities({
                        id: discount_id
                    }).$promise.then(function(response) {
                        notificationSrvc.notification("success", discountMessagesConst.updateSuccess);
                        activate();
                    }, function(response) {
                        errorNotificationSrvc.displayErrors(response.data);
                        self.loading = false;
                    })
                },
                angular.noop
            );
        }

        function cleanImportErrors(key){
            self.importServerErrors[key] = [];
        }

        function importDiscountsFromFile(){
            self.uploading = true;

            discountDataSrvc.importDiscountsForQuantity(
                self.importData
            ).$promise.then(function (response) {
                    discountModalSrvc.updateModal(response, activate, angular.noop)
                    self.uploading = false;
                },
                function (response) {
                    self.importServerErrors = response.data;
                    self.uploading = false;
                    errorNotificationSrvc.displayErrors(response.data);
                }
            )
        }
    }
})();
